// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { loadSelectItems } from "#/admin/legacy/sp-select/load-select-items.js";

/** Matches the completion page's redirect page picker. */
export const REDIRECT_PAGE_SELECT = 'sp-select[name="page_id"]';

/** Returns the completion page template context with the translated redirect page placeholder. */
export function completionPageContext(context) {
  return {
    ...context,
    redirectPagePlaceholder: globalThis.Sparkle.t(
      "admin.definition_list_form.labels.assessment.redirect_page_placeholder",
    ),
  };
}

/** Loads the redirect pages into `root`'s page picker with a blank choice and `pageId` selected. */
export function loadRedirectPages(root, pageId) {
  const pageIdSelect = root.querySelector('[name="page_id"]');

  if (!pageIdSelect) {
    return;
  }

  return loadSelectItems(pageIdSelect, "/admin/pages.json?order=recently_added&limit=1000&offset=0", {
    selected: pageId,
    includeBlank: true,
    allPages: true,
  });
}

/** Returns the title of the page `control` selects, or "" for the blank choice. */
export function redirectPageTitle(control) {
  const selected = control.items.find((item) => String(item.value) === String(control.value));
  const title = selected?.placeholder ? "" : selected?.title;

  return title || "";
}
